module.exports = __webpack_public_path__ + "static/media/dushuhui.a50c5bff.jpg";